var map = {
	"./CB0000_rabbit_stroke.png": "6bc1",
	"./CB0010_bear_stroke.png": "9e71",
	"./CB0020_cat_stroke.png": "f8a6",
	"./CB0030_hamster_stroke.png": "04bf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7650";